var _g, _defs;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 250,
    viewBox: "0 0 250 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125 250C194.036 250 250 194.036 250 125C250 55.9644 194.036 0 125 0C55.9644 0 0 55.9644 0 125C0 194.036 55.9644 250 125 250Z",
    fill: "#FBDFD6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.08 231.838C79.0025 243.36 101.225 250 125 250C148.775 250 170.998 243.36 189.92 231.838L200 124.998H50L60.08 231.838Z",
    fill: "#F26335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 124.998L52.0625 146.868C62.8175 161.808 91.405 172.495 125 172.495C158.595 172.495 187.185 161.808 197.938 146.865L200 124.998H50Z",
    fill: "#9D3311"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.47 114.93C203.768 121.227 202.5 128.512 202.5 128.745C202.5 150.147 167.803 167.495 125 167.495C82.1976 167.495 47.5001 150.147 47.5001 128.745C47.5001 128.597 46.3702 120.997 52.3927 114.975C56.8727 109.942 193.08 109.917 197.47 114.93Z",
    fill: "#F26335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125 84.9976C166.42 84.9976 200 101.228 200 121.248C200 141.268 166.42 157.498 125 157.498C83.58 157.498 50 141.27 50 121.248C50 101.228 83.58 84.9976 125 84.9976Z",
    fill: "#BC3D15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125 94.9976C162.91 94.9976 194.23 108.595 199.272 126.248C199.74 124.613 200 122.945 200 121.248C200 101.228 166.42 84.9976 125 84.9976C83.58 84.9976 50 101.228 50 121.248C50 122.945 50.26 124.613 50.7275 126.248C55.77 108.595 87.09 94.9976 125 94.9976Z",
    fill: "#9D3311"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.5 187.495C82.5 184.735 80.26 182.498 77.5 182.498C74.74 182.498 72.5 184.738 72.5 187.495L76.26 240.14C79.6075 241.558 83.0425 242.813 86.5325 243.943L82.5 187.495ZM105 192.495C105 189.735 102.76 187.495 100 187.495C97.24 187.495 95 189.735 95 192.495L97.09 246.833C100.402 247.588 103.758 248.225 107.163 248.71L105 192.495ZM172.5 182.498C169.74 182.498 167.5 184.738 167.5 187.495L163.47 243.94C166.96 242.813 170.393 241.558 173.74 240.138L177.5 187.495C177.5 184.738 175.26 182.498 172.5 182.498ZM130 249.873V194.995C130 192.235 127.76 189.995 125 189.995C122.24 189.995 120 192.235 120 194.995V249.873C121.662 249.938 123.322 250 125 250C126.678 250 128.34 249.94 130 249.873ZM150 187.495C147.24 187.495 145 189.735 145 192.495L142.837 248.71C146.242 248.225 149.6 247.588 152.91 246.833L155 192.495C155 189.738 152.76 187.495 150 187.495Z",
    fill: "#9D3311"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 250,
    height: 250
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125 250C194.036 250 250 194.036 250 125C250 55.9644 194.036 0 125 0C55.9644 0 0 55.9644 0 125C0 194.036 55.9644 250 125 250Z",
    fill: "#FBDFD6"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.186 -8C109.977 -8 108.186 -6.20914 108.186 -4V35.5772H99.006C96.3333 35.5772 94.9948 38.8086 96.8847 40.6985L122.642 66.4559C123.814 67.6274 125.713 67.6274 126.885 66.4559L152.642 40.6985C154.532 38.8086 153.193 35.5772 150.521 35.5772H142.186V-4C142.186 -6.20914 140.395 -8 138.186 -8H112.186Z",
    fill: "#E19880"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 250,
    height: 250,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.b1bcabf719fd5d273c2e21a0b3a64342.svg";
export { ForwardRef as ReactComponent };